// @ts-ignore Ignore unused commented ActionTypes import
import { AppActions } from './actions';
import { AppState } from '../shared/models/shared.model';

export const initialState = {};

// add switch cased to the reducer for every action
// or combine reducers from the reducers subfolder right here
export function appReducer(state: AppState = initialState, action: AppActions): AppState {
  switch (action.type) {
    // case ActionTypes.SomeAction: {
    //
    // }

    default:
      return state;
  }
}
